
import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
    Form,
    Input,
    Label,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Alert
} from "reactstrap"
import classnames from "classnames"
import { connect } from "react-redux"

//Import Action
import {
    setBreadcrumbItems,
    getSystemSettings,
    updateSystemSettings
} from "../../../store/actions"

const SystemSettings = (props) => {
    document.title = "Paramètres Système | CRM Admin";

    const [activeTab, setActiveTab] = useState("1")
    const [formValues, setFormValues] = useState([])
    const [successMessage, setSuccessMessage] = useState("")

    const breadcrumbItems = [
        { title: "CRM", link: "#" },
        { title: "Admin", link: "#" },
        { title: "Paramètres Système", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Paramètres Système", breadcrumbItems)
        props.getSystemSettings()
    }, [])

    useEffect(() => {
        if (props.settings) {
            setFormValues(props.settings.map(s => ({ key: s.key, value: s.value || "" })))
        }
    }, [props.settings])

    const toggleTab = tab => {
        if (activeTab !== tab) setActiveTab(tab)
    }

    const handleInputChange = (key, value) => {
        setFormValues(prev => prev.map(item => item.key === key ? { ...item, value } : item))
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const settingsToUpdate = formValues.filter(fv => {
            const original = props.settings.find(s => s.key === fv.key);
            return original && original.value !== fv.value;
        });

        if (settingsToUpdate.length > 0) {
            props.updateSystemSettings(settingsToUpdate)
            setSuccessMessage("Paramètres enregistrés avec succès !")
            setTimeout(() => setSuccessMessage(""), 3000)
        }
    }

    const renderSettingField = (setting) => {
        const value = formValues.find(fv => fv.key === setting.key)?.value || ""

        return (
            <div className="mb-4" key={setting.key}>
                <Label className="fw-bold">{setting.description || setting.key}</Label>
                <div className="text-muted font-size-12 mb-2">Clé: <code>{setting.key}</code></div>
                {setting.type === 'integer' ? (
                    <Input
                        type="number"
                        value={value}
                        onChange={e => handleInputChange(setting.key, e.target.value)}
                    />
                ) : setting.key.includes('password') || setting.key.includes('secret') ? (
                    <Input
                        type="password"
                        value={value}
                        onChange={e => handleInputChange(setting.key, e.target.value)}
                        placeholder="********"
                    />
                ) : (
                    <Input
                        type="text"
                        value={value}
                        onChange={e => handleInputChange(setting.key, e.target.value)}
                    />
                )}
            </div>
        )
    }

    const groups = {
        "1": "general",
        "2": "email",
        "3": "payment"
    }

    return (
        <React.Fragment>
            <Row>
                <Col lg="12">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4 mb-4">Configuration Globale du Système</CardTitle>

                            {successMessage && <Alert color="success">{successMessage}</Alert>}

                            <Nav tabs className="nav-tabs-custom nav-justified">
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "1" })}
                                        onClick={() => toggleTab("1")}
                                    >
                                        <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                        <span className="d-none d-sm-block">Général</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "2" })}
                                        onClick={() => toggleTab("2")}
                                    >
                                        <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                        <span className="d-none d-sm-block">Configuration Email (SMTP)</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "3" })}
                                        onClick={() => toggleTab("3")}
                                    >
                                        <span className="d-block d-sm-none"><i className="far fa-credit-card"></i></span>
                                        <span className="d-none d-sm-block">Paiements & TVA</span>
                                    </NavLink>
                                </NavItem>
                            </Nav>

                            <TabContent activeTab={activeTab} className="p-3 text-muted">
                                {Object.keys(groups).map(tabId => (
                                    <TabPane tabId={tabId} key={tabId}>
                                        <Form onSubmit={handleSubmit} className="mt-4">
                                            <Row>
                                                <Col lg="8">
                                                    {(props.settings || [])
                                                        .filter(s => s.group === groups[tabId])
                                                        .map(setting => renderSettingField(setting))
                                                    }
                                                    <div className="mt-4">
                                                        <Button type="submit" color="primary" className="px-4">
                                                            Enregistrer les modifications
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col lg="4">
                                                    <div className="p-4 bg-light rounded">
                                                        <h6><i className="mdi mdi-information-outline text-primary me-1"></i> Aide</h6>
                                                        <p className="font-size-13 mb-0">
                                                            Ces paramètres affectent l'ensemble de la plateforme.
                                                            Assurez-vous de valider vos configurations SMTP avant de mettre en production pour garantir l'envoi des emails.
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </TabPane>
                                ))}
                            </TabContent>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        settings: state.SettingsAdmin.settings,
    }
}

export default connect(mapStateToProps, {
    setBreadcrumbItems,
    getSystemSettings,
    updateSystemSettings
})(SystemSettings)
